import { PropsWithChildren } from 'react';

import fieldStyles from '@shared/components/FormFields/FormFields.module.scss';

interface FieldWrapperProps {
  labelText: string;
  fieldType: string;
}

export function FieldWrapper({ children, fieldType, labelText }: PropsWithChildren<FieldWrapperProps>) {
  return (
    <div className={fieldStyles.fieldWrapper}>
      <label htmlFor={fieldType} className={fieldStyles.fieldLabel}>
        {labelText}
      </label>
      {children}
    </div>
  );
}
